import { useIntl } from 'react-intl';

import { useWindowSize } from '@xing-com/crate-jobs-hooks';
import type { TipBoxPresetProps } from '@xing-com/tip-box';
import { TipBoxPreset } from '@xing-com/tip-box';

const MIN_BOTTOM_POSITION = 1200;

export type FindJobsTipBoxProps = {
  variant: 'input' | 'promotions';
  show: boolean;
  onClickNext: () => void;
  onClose: () => void;
  tipBoxProps?: Partial<TipBoxPresetProps>;
};

export const FindJobsTipBox: React.FC<
  React.PropsWithChildren<FindJobsTipBoxProps>
> = ({ children, show, tipBoxProps, variant, onClickNext, onClose }) => {
  const { formatMessage } = useIntl();
  const { width } = useWindowSize();

  const content: Partial<TipBoxPresetProps> = {
    bodyText: formatMessage({
      id:
        variant === 'input'
          ? 'JOBS_FIND_JOBS_GUIDANCE_SEARCH_INPUT_TEXT'
          : 'JOBS_FIND_JOBS_GUIDANCE_QUERIES_TEXT',
    }),
    buttonLabel: formatMessage({
      id:
        variant === 'input'
          ? 'JOBS_FIND_JOBS_GUIDANCE_SEARCH_INPUT_BUTTON'
          : 'JOBS_FIND_JOBS_GUIDANCE_QUERIES_BUTTON',
    }),
    headlineText: formatMessage({
      id:
        variant === 'input'
          ? 'JOBS_FIND_JOBS_GUIDANCE_SEARCH_INPUT_HEADLINE'
          : 'JOBS_FIND_JOBS_GUIDANCE_QUERIES_HEADLINE',
    }),
    markerText: formatMessage({
      id:
        variant === 'input'
          ? 'JOBS_FIND_JOBS_GUIDANCE_SEARCH_INPUT_MARKER'
          : 'JOBS_FIND_JOBS_GUIDANCE_QUERIES_MARKER',
    }),
  };

  const onDisableAutofocus = (e: Event): void => {
    e.preventDefault();
  };

  const onInteractOutside = (e: Event): void => {
    // We don't want to close the tip box when clicking outside of it
    e.preventDefault();
  };

  return (
    <TipBoxPreset
      align="center"
      buttonProps={{ onClick: onClickNext }}
      showArrow
      open={show}
      showClosingIndicator={false}
      side={(width ?? 0) <= MIN_BOTTOM_POSITION ? 'bottom' : 'right'}
      variant="highlighted"
      trigger={children}
      onOpenAutoFocus={onDisableAutofocus}
      onOpenChange={onClose}
      onInteractOutside={onInteractOutside}
      {...content}
      {...tipBoxProps}
    />
  );
};
